export default "assets/images/logo-sowine-b7d45366.png";